import 'regenerator-runtime/runtime.js';
import Bugsnag from '@bugsnag/js';
import { ErrorReporter } from './ErrorReporter.js';
import { BugsnagProvider } from './providers/BugsnagProvider.js';
import { CrashlyticsProvider } from './providers/CrashlyticsProvider.js';
import { ReporterProvider } from './contracts/ReporterProvider.js';
import { detectEnvironment } from './config.js';

// Automatically initialize on import/load
if (typeof window !== 'undefined') {
  // Register alternative providers so they are immediately available if requested
  ErrorReporter.register('crashlytics', new CrashlyticsProvider());

  // Initialize with detected environment
  ErrorReporter.init();

  // Expose globally for vanilla JS / jQuery scripts throughout the site
  window.ErrorReporter = ErrorReporter;
  window.Bugsnag = Bugsnag;

  // Auto-detect user data from DOM meta tags if present
  const userIdMeta = document.querySelector('meta[name="user-id"]');
  const userEmailMeta = document.querySelector('meta[name="user-email"]');
  const userNameMeta = document.querySelector('meta[name="user-name"]');

  if (userIdMeta || userEmailMeta || userNameMeta) {
    ErrorReporter.setUser({
      id: userIdMeta ? userIdMeta.getAttribute('content') : undefined,
      email: userEmailMeta ? userEmailMeta.getAttribute('content') : undefined,
      name: userNameMeta ? userNameMeta.getAttribute('content') : undefined,
    });
  }

  // Also support window.__USER__ if set
  if (window.__USER__ && typeof window.__USER__ === 'object') {
    ErrorReporter.setUser(window.__USER__);
  }

  // Capture unhandled jQuery Ajax errors (HTTP 5xx)
  window.addEventListener('DOMContentLoaded', () => {
    if (window.jQuery) {
      window.jQuery(document).ajaxError((event, jqXHR, settings) => {
        if (jqXHR.status >= 500) {
          ErrorReporter.leaveBreadcrumb(
            'ajax_error',
            {
              url: settings.url,
              status: jqXHR.status,
              type: settings.type,
            },
            'request'
          );
          ErrorReporter.notify(
            new Error(`Ajax Error [${jqXHR.status}] ${settings.type || 'GET'} ${settings.url}`),
            {
              ajax: {
                url: settings.url,
                status: jqXHR.status,
                statusText: jqXHR.statusText,
              },
            }
          );
        }
      });
    }
  });
}

export {
  ErrorReporter,
  BugsnagProvider,
  CrashlyticsProvider,
  ReporterProvider,
  detectEnvironment,
};

export default ErrorReporter;



// WEBPACK FOOTER //
// ./resources/assets/js/monitoring/index.js